import {
  ComoLidarComAvisoPrevioNaoCumprido,
  Motivo,
} from '@octopus/termination-api';

import { TerminationSimulationInputs } from './types';

export const TABS = [
  {
    label: 'Colaboradores',
    value: 'collaborators',
  },
  {
    label: 'Simulações',
    value: 'simulations',
  },
];

export const terminationReason: Record<Motivo, string> = {
  comJustaCausa: 'Rescisão com justa causa, por iniciativa do empregador',
  semJustaCausa: 'Rescisão sem justa causa, por iniciativa do empregador',
  rescisaoAntecipadaDoContratoDeExperienciaPeloEmpregador:
    'Rescisão antecipada do contrato a termo por iniciativa do empregador',
  rescisaoAntecipadaDoContratoDeExperienciaPeloEmpregado:
    'Rescisão antecipada do contrato a termo por iniciativa do empregado',
  rescisaoJovemAprendizATermo: 'Rescisão por término do contrato a termo',
  pedidoDeDemissao:
    'Rescisão do contrato de trabalho por iniciativa do empregado',
  falecimento: 'Rescisão por falecimento do empregado',
  extincaoDeContratoDeExperiencia:
    'Rescisão por término do contrato de experiência',
  mutuoAcordo: 'Rescisão por acordo entre as partes (art. 484-A da CLT)',
};

export const typeOfNotice: Record<ComoLidarComAvisoPrevioNaoCumprido, string> =
  {
    indenizado: 'Indenizado',
    dispensado: 'Dispensado',
    impedidoDeTrabalhar: 'Impedido de trabalhar',
    empregadoTemNovoEmprego: 'Empregado tem novo emprego',
  };

export const formInputKeys: Record<
  keyof TerminationSimulationInputs,
  keyof TerminationSimulationInputs
> = {
  identifier: 'identifier',
  reason: 'reason',
  terminationDate: 'terminationDate',
  noticeType: 'noticeType',
  noticeStartDate: 'noticeStartDate',
  fgtsBalance: 'fgtsBalance',
  paymentDate: 'paymentDate',
};

export const initialFormInputs: TerminationSimulationInputs = {
  identifier: '',
  reason: undefined,
  terminationDate: undefined,
  noticeType: undefined,
  noticeStartDate: undefined,
  fgtsBalance: '',
  paymentDate: undefined,
};
